import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'

function getMessage(field, args) {
  return `The ${field} cannot be earlier than the date of application.`
}

function validate(value, args) {
  if (value) {
    const today = removeTime(new Date())
    const startDate = removeTime(value)
    // if (isAfter(today, startDate)) return false
    // else return true
    return !(isAfter(today, startDate))
  } else return true
}

export default {
  getMessage,
  validate
}
